/**
 * Envío NR-1 · aviso debajo del botón de generar con lo que le falta al nodo.
 * No se muestra si no falta nada o si el nodo está trabajando.
 * `optional` (ND-1): lo que se puede completar pero no es obligatorio.
 */
import { memo } from 'react';
import { Info } from 'lucide-react';

const NodeRequirements = memo(({ missing, optional = [], hidden = false }) => {
  if (hidden || !missing || !missing.length) return null;
  return (
    <div className="node-requirements" role="status" data-testid="node-requirements">
      <div className="node-requirements-head">
        <Info size={12} aria-hidden="true" />
        <span>Para generar falta:</span>
      </div>
      <ul>
        {missing.map((m) => <li key={m}>{m}</li>)}
      </ul>
      {optional && optional.length > 0 && (
        <p className="node-requirements-optional">Opcional: {optional.join('; ')}.</p>
      )}
    </div>
  );
});

NodeRequirements.displayName = 'NodeRequirements';
export default NodeRequirements;
